/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { generatePopularVehiclesEn, VehiclePreset } from './popularVehicles';

export type Language = 'en';

export const englishTranslations = {
  title: 'Fuel Analyzer',
  subtitle: 'Vehicle Health Intelligence',
  saveVehicle: 'Save Vehicle Profile',
  saveBtn: 'Save Vehicle Profile',
  editBtn: 'Edit Profile',
  cancelBtn: 'Cancel',
  brand: 'Vehicle Brand',
  model: 'Vehicle Model',
  year: 'Model Year',
  capacity: 'Tank Capacity',
  currentOdo: 'Current Odometer',
  customSelect: '-- Custom brand/model --',
  orEnterCustom: 'Or enter custom brand/model manually:',
  profileTitle: 'Your Vehicle Profile',
  quickFill: 'Smart Regional Presets',
  fuelFormTitle: 'Log New Refueling',
  fuelFormSub: 'Enter fueling data for automatic analytical reporting',
  fuelTypeLabel: 'Fuel Type',
  odoPlaceholder: 'Higher than previous odometer',
  odoLabel: 'Current Odometer (km) *',
  litersLabel: 'Fuel Amount (Liters) *',
  costLabel: 'Total Paid Cost *',
  stationLabel: 'Station Name or Location (Optional)',
  notesLabel: 'Technical Notes / Comments (Optional)',
  submitRefuel: 'Submit Refuel Data',
  odoError: 'Odometer reading must be higher than previous odometer.',
  valuesError: 'Please enter valid values greater than zero.',
  vhsTitle: 'Vehicle Health Score (VHS)',
  vhsSub: 'Diagnostic rating based on consumption dynamics and engine stability',
  avgEff: 'Average Consumption',
  estRange: 'Est. Fuel Range',
  co2Metric: 'Monthly CO₂ Footprint',
  fluctuation: 'Efficiency Fluctuat.',
  factorAnalysis: 'Four-Factor Health Metric Analysis',
  effFactor: 'Fuel Efficiency (Consumption performance)',
  maintFactor: 'Wear & Maintenance (Engine pressure factor)',
  habitFactor: 'Fueling Consistency (Driving behaviors)',
  costFactor: 'Fuel Cost Balance (Value relative to mileage)',
  warningsTitle: 'AI Health Intelligence & Diagnostic Alerts',
  emptyLogsTitle: 'Fuel Logs is Empty',
  emptyLogsSub: 'No fueling entries found. Log your first fuel tank details above to start tracking.',
  recentLogsTitle: 'Recent Refuel History',
  orderNewest: 'Order: Newest First',
  odoRegistered: 'Logged Odometer',
  litersRegistered: 'Fuel Filled',
  costPaid: 'Paid Cost',
  logEffLabel: 'Refuel Efficiency:',
  logEffSub: 'Calculating interval fuel efficiency requires subsequent fuel entry.',
  noteLabel: 'Tech Notes:',
  aiReportTitle: 'AI Technician Diagnostics',
  aiReportSub: 'Deep diagnostic engine analysis powered by Gemini AI',
  aiBtn: 'Request Intelligent Diagnostic Report',
  aiRegen: 'Analyze Again',
  aiSuggestTitle: 'Common Tech Diagnostics:',
  aiPromptPlaceholder: 'Specific question (e.g., Engine vibrates on cold start)',
  aiFooterNote: 'Diagnostics tailored explicitly based on your vehicle model and fueling history.',
  costSum: 'Total Fuel Spent',
  volumeSum: 'Total Liters Filled',
  avgCostLiter: 'Avg. Cost Per Liter',
  efficiencyChartTitle: 'Fuel Consumption Trend (L/100km)',
  costChartTitle: 'Refueling Cost Analysis',
  currency: '€',
  liters: 'Liters',
  km: 'km',
  tabDashboard: 'Dashboard',
  tabVehicles: 'Vehicles',
  tabRefuel: 'Refuel',
  tabHistory: 'History',
  tabAi: 'AI Technician',
  exportCSV: 'Export CSV Backup',
  importCSV: 'Import CSV Data',
  exportCSVSub: 'Download full refueling logs in standard CSV format',
  importCSVSub: 'Restore or merge fuel entries from a CSV file',
  resetAll: 'Reset All Local Analytics',
  offlineNote: 'Modern geometric offline-ready telemetry system',
  shareReportText: 'Diagnostic text report successfully copied to your clipboard!',
  confirmDelete: 'Are you sure you want to delete this fueling log?',
  confirmReset: 'WARNING! This will clear all local vehicle data & fuel history. Proceed?',
  emptyProfileWarning: 'Please save your vehicle profile first.',
  levelExcellent: 'Excellent',
  levelGood: 'Good',
  levelFair: 'Fair',
  levelPoor: 'Needs Diagnostic',
  selectVehiclePlaceholder: 'Quick select a popular vehicle...',
  customVehicleInput: 'Enter other brand/model...',
  printableTitle: 'Vehicle Diagnostics & Fuel Economy Report',
  printableSub: 'Generated dynamically by Fuel Analyzer Smart Telemetry',
  printableDate: 'Report Date',
};

export const translations = {
  en: englishTranslations,
};

export const popularVehiclesEn = generatePopularVehiclesEn();

